import { enabledFeatures } from "./Config";
export const getEnabledFeatures = async () => {
	return enabledFeatures;
};
